module.exports = __webpack_public_path__ + "img/MQ.50fc580b.svg";